import { defineMessages } from 'react-intl'

const scope = `procurify.expense.ApproverChoiceSelect`

export default defineMessages({
  placeholderText: {
    id: `${scope}.placeholderText`,
    defaultMessage: 'Select next approver',
  },
  delegatedToLabel: {
    id: `${scope}.delegatedToLabel`,
    defaultMessage: 'Delegated to: {user}',
  },
  selfApprovalLabel: {
    id: `${scope}.selfApprovalLabel`,
    defaultMessage: 'self-approve',
  },
})
